// extracted by mini-css-extract-plugin
export default {"dialog":"modalLayout_dialog__zOHGU","content":"modalLayout_content__wBqoI"};